export enum TournamentCategoryType {
  SINGLE = 'SINGLE',

  DOUBLE = 'DOUBLE',

  TEAM = 'TEAM',
}
